import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../../colorVars';
import CloseWindowButton from '../../../../../../../../../atomic/buttons/closeWindow/CloseWindowButton';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { useAlertFormStore } from '../../../../alertFormClass';
import style from './TimeOfDayModule.module.css';
import { BoxInput } from '../../../../../../../../../atomic/inputs/boxInput/BoxInput';

export const TimeOfDayModule = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <div></div>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Time Of Day
        </Body3>
        <CloseWindowButton
          margin="0 0 7px 5px"
          width={10}
          stroke={2}
          color={colors.red}
          handleClick={() => form.removeSetupFilter('TIME_OF_DAY')}
        />
      </header>
      <div className={style.body}>
        <Body3 margin="5px auto" fontWeight={500} color={colors.lightGrey}>
          Time is EST 24hr format.
        </Body3>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Start Time
        </Body3>

        <div className={style.start}>
          <div className={style.inputAndLabel}>
            <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
              Hour:
            </Body3>
            <BoxInput value={form.setupFilters['TIME_OF_DAY'].startHour} setValue={(value) => form.updateSetupFilterField('TIME_OF_DAY', 'startHour', value)} fontSize={fontSizes.body3} backgroundColor={colors.black} width="40px" />
          </div>
          <div className={style.inputAndLabel}>
            <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
              Minute:
            </Body3>
            <BoxInput value={form.setupFilters['TIME_OF_DAY'].startMinute} setValue={(value) => form.updateSetupFilterField('TIME_OF_DAY', 'startMinute', value)} fontSize={fontSizes.body3} backgroundColor={colors.black} width="40px" />
          </div>
        </div>

        <Body3 fontWeight={700} color={colors.lightGrey}>
          End Time
        </Body3>

        <div className={style.end}>
          <div className={style.inputAndLabel}>
            <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
              Hour:
            </Body3>
            <BoxInput value={form.setupFilters['TIME_OF_DAY'].endHour} setValue={(value) => form.updateSetupFilterField('TIME_OF_DAY', 'endHour', value)} fontSize={fontSizes.body3} backgroundColor={colors.black} width="40px" />
          </div>
          <div className={style.inputAndLabel}>
            <Body3 margin="0 3px 0 0" fontWeight={500} color={colors.lightGrey}>
              Minute:
            </Body3>
            <BoxInput value={form.setupFilters['TIME_OF_DAY'].endMinute} setValue={(value) => form.updateSetupFilterField('TIME_OF_DAY', 'endMinute', value)} fontSize={fontSizes.body3} backgroundColor={colors.black} width="40px" />
          </div>
        </div>
      </div>
    </div>
  );
});
